<template>
  <div class="checkout-payment-failed checkout-feedback-screen flow-step">
    <h1>Algo inesperado aconteceu</h1>
    <img src="@/assets/junior-error.png" alt />
    <p>Encontramos um erro na aprovação do cartão</p>
    <span>
      Tente novamente!<br/>Caso o erro persista, por favor, entre em contato com nossa
      <a href="https://help.playkids.com" target="_blank">equipe de atendimento!</a>
    </span>
    <btn color="purple" @click="$emit('restartPayment')">Recomeçar</btn>
  </div>
</template>

<script>
export default {
  name: 'checkout-payment-failed'
}
</script>
